/**
 * @generated SignedSource<<e7305ac82ac2f1d87619f86e571870b6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type TodoStatus = "DONE" | "PENDING";
import { FragmentRefs } from "relay-runtime";
export type WidgetTodoOverviewContentMediumPaginated$data = {
  readonly category: {
    readonly id: string;
  } | null;
  readonly id: string;
  readonly teams: ReadonlyArray<{
    readonly id: string;
  }>;
  readonly todoContent: {
    readonly todos?: {
      readonly __id: string;
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly ordinal: string;
          readonly status: TodoStatus;
          readonly " $fragmentSpreads": FragmentRefs<"TodoDetailContentMain_todo" | "TodoOverviewListItemMedium_Todo">;
        };
      }>;
    } | null;
  };
  readonly " $fragmentType": "WidgetTodoOverviewContentMediumPaginated";
};
export type WidgetTodoOverviewContentMediumPaginated$key = {
  readonly " $data"?: WidgetTodoOverviewContentMediumPaginated$data;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetTodoOverviewContentMediumPaginated">;
};

const node: ReaderFragment = (function(){
var v0 = [
  "todoContent",
  "todos"
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  (v1/*: any*/)
];
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "after"
    },
    {
      "kind": "RootArgument",
      "name": "first"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "first",
        "cursor": "after",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "first",
          "cursor": "after"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [
        "node"
      ],
      "operation": require('./WidgetTodoOverviewContentMediumPaginatedQuery.graphql'),
      "identifierInfo": {
        "identifierField": "id",
        "identifierQueryVariableName": "id"
      }
    }
  },
  "name": "WidgetTodoOverviewContentMediumPaginated",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Team",
      "kind": "LinkedField",
      "name": "teams",
      "plural": true,
      "selections": (v2/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TodoCategory",
      "kind": "LinkedField",
      "name": "category",
      "plural": false,
      "selections": (v2/*: any*/),
      "storageKey": null
    },
    {
      "alias": "todoContent",
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "content",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": "todos",
              "args": null,
              "concreteType": "TodoConnection",
              "kind": "LinkedField",
              "name": "__WidgetTodoOverviewContentMedium__todos_connection",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "TodoEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Todo",
                      "kind": "LinkedField",
                      "name": "node",
                      "plural": false,
                      "selections": [
                        (v1/*: any*/),
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "ordinal",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "status",
                          "storageKey": null
                        },
                        {
                          "args": null,
                          "kind": "FragmentSpread",
                          "name": "TodoDetailContentMain_todo"
                        },
                        {
                          "args": null,
                          "kind": "FragmentSpread",
                          "name": "TodoOverviewListItemMedium_Todo"
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "__typename",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "cursor",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "PageInfo",
                  "kind": "LinkedField",
                  "name": "pageInfo",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "endCursor",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "hasNextPage",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "kind": "ClientExtension",
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__id",
                      "storageKey": null
                    }
                  ]
                }
              ],
              "storageKey": null
            }
          ],
          "type": "WidgetTodoOverviewContentMedium",
          "abstractKey": null
        }
      ],
      "storageKey": null
    },
    (v1/*: any*/)
  ],
  "type": "WidgetTodoOverview",
  "abstractKey": null
};
})();

(node as any).hash = "fd60da9a86aa9f78aab6d40018657a12";

export default node;
